<script lang="ts">
import { classname } from '@/js/utils.js';
import BaseInputSwitch from '@/js/vue/base/base-switch.vue';

const classStatus = classname('status');

export default {
  name: 'AppStatus',
  components: { BaseInputSwitch },
  inheritAttrs: false,
  methods: {
    classStatus,
  },
};
</script>

<template>
  <div :class="classStatus()">
    <BaseInputSwitch v-bind="$attrs">
      <slot />
    </BaseInputSwitch>
  </div>
</template>

<style lang="scss">
.status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 26px;
  border-top: 1px solid #c4c4c4;

  @media screen and (max-width: 500px) {
    padding-top: 18px;
  }
}
</style>
